import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import EditIcon from "../../UI/svg/EditIcon";
import * as commonData from "../../../Common";

const BoardListing = (props) => {
  const data = useSelector((state) => state.loginDetails);

  const color = useMemo(() => getRandomColor(), []);
  const { board_data } = props;

  function getRandomColor() {
    var letters = "0123456789ABCDEF";
    var color = "#";
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  // this function is use for edit the of board renaming
  const editName = () => {
    props.editName();
  };

  const get_short_name = (name) => {
    if (name.includes(" ")) {
      const words = name.split(" ");
      return words.map((word) => word.charAt(0)).join("");
    } else {
      return name.substring(0, 2);
    }
  };
  const attribute_set_key = board_data.attribute_set_key;
  const attribute_set_name = board_data.attribute_set_name;
  const app_token = commonData.getCommonData().app_token;
  let link;
  if (props.setting?.attribute_set_type === 4) {
    link = `/tattle/${board_data.attribute_set_key}/kanban`;
  } else {
    link = `/tattle/${board_data.attribute_set_key}/list`;
  }
  return (
    <div class="todo-input board-list-box">
      <Link
        to={{
          pathname: link,
          state: { data: board_data },
        }}
      >
        <div class="left-div" style={{ background: board_data?.color }}>
          {get_short_name(board_data?.attribute_set_name)}
        </div>
        <div class="right-div">{board_data.attribute_set_name}</div>
      </Link>

      {props.isAdmin === 1 && (
        <div class="hover-menu">
          <div class="dropdown mu-dropdown">
            <div
              class="muBtn icon-only dropdown-toggle ps-2 pe-2"
              id="dropdownMenuReference"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              data-bs-reference="parent"
            >
              <span class="svg">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                    stroke="black"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                  <path
                    d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                    stroke="black"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                  <path
                    d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                    stroke="black"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </span>
            </div>
            <div class="dropdown-menu dropdown-menu-end">
              {(props.deactive || props.deactivate) && (
                <div class="dropdown-item" onClick={editName}>
                  <div class="d-flex align-items-center">
                    <span class="svg me-2">
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.9165 1.75009C10.0697 1.59689 10.2516 1.47535 10.4518 1.39244C10.652 1.30952 10.8665 1.26685 11.0832 1.26685C11.2998 1.26685 11.5144 1.30952 11.7146 1.39244C11.9147 1.47535 12.0966 1.59689 12.2498 1.75009C12.403 1.9033 12.5246 2.08519 12.6075 2.28537C12.6904 2.48554 12.7331 2.70009 12.7331 2.91676C12.7331 3.13343 12.6904 3.34798 12.6075 3.54816C12.5246 3.74833 12.403 3.93022 12.2498 4.08343L4.37484 11.9584L1.1665 12.8334L2.0415 9.62509L9.9165 1.75009Z"
                          stroke="#303049"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                    </span>
                    Edit Name
                  </div>
                </div>
              )}
              <div
                class="dropdown-item"
                onClick={props.deactive ? props.deactivate : props.active_board}
              >
                <div class="d-flex align-items-center">
                  <span class="svg me-2">
                    <i className="fa fa-ban"></i>
                  </span>

                  {props.deactive ? "Deactivate" : "Activate"}
                </div>
              </div>
              {(props.deactive || props.deactivate) && (
                <Link
                  style={{ color: "inherit", textDecoration: "none" }}
                  to={{
                    pathname: `/${attribute_set_key}/manage-notifications`,
                    state: {
                      attribute_set_key,
                      attribute_set_name,
                      app_token,
                    },
                  }}
                >
                  {" "}
                  <div class="dropdown-item">
                    <div class="d-flex align-items-center">
                      <span class="svg me-2">
                        <i className="fa fa-bell"></i>
                      </span>{" "}
                      Notification
                    </div>
                  </div>
                </Link>
              )}
              {props.deactive || props.deactivate ? (
                <Link
                  to={{
                    pathname: `/tattle/${props.setting.set_key}/settings`,
                    state: { data: { ...props?.setting } },
                  }}
                  className="setting-status"
                >
                  <div class="dropdown-item">
                    {" "}
                    <div class="d-flex align-items-center">
                      <span class="svg me-2">
                        <EditIcon />
                      </span>
                      Settings
                    </div>{" "}
                  </div>
                </Link>
              ) : (
                ""
              )}

              <div class="dropdown-item" onClick={props.deleteBoard}>
                <div class="d-flex align-items-center">
                  <span class="svg me-2">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1.75 3.5H2.91667H12.25"
                        stroke="#7B8794"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M4.6665 3.50008V2.33341C4.6665 2.024 4.78942 1.72725 5.00821 1.50846C5.22701 1.28966 5.52375 1.16675 5.83317 1.16675H8.1665C8.47592 1.16675 8.77267 1.28966 8.99146 1.50846C9.21026 1.72725 9.33317 2.024 9.33317 2.33341V3.50008M11.0832 3.50008V11.6667C11.0832 11.9762 10.9603 12.2729 10.7415 12.4917C10.5227 12.7105 10.2259 12.8334 9.91651 12.8334H4.08317C3.77375 12.8334 3.47701 12.7105 3.25821 12.4917C3.03942 12.2729 2.9165 11.9762 2.9165 11.6667V3.50008H11.0832Z"
                        stroke="#7B8794"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M5.8335 6.41675V9.91675"
                        stroke="#7B8794"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M8.1665 6.41675V9.91675"
                        stroke="#7B8794"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </span>
                  Delete Board
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BoardListing;
